import { useMutation } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


export const useStartTeleconsultation = () => {
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (consultationId: string) => {
      return api.post(`teleconsultation/${consultationId}/start`);
    },

    onError: (res: any) => {
      console.error("[From Start Teleconsultation]", res);

      handleErrors(res, "mutation");
    },
  });
};
